import React, { memo, useMemo } from 'react';
import GamesViewMini from 'js/components/common/GamesView/GamesViewMini';
import style from './GameInfoDesktop.scss';
import { ShortGameDescription } from '../../../components/GameInfo/components/ShortGameDescription/ShortGameDescription';
import GameInfoTopSectionDesktop from './components/GameInfoTopSectionDesktop/GameInfoTopSectionDesktop';
import { useLiveGameConfig, useLiveGames } from '@core/js/hooks/games';

export const GameInfoDesktop = ({
    image,
    name,
    showFavorite,
    description,
    code,
    hideButtons,
    gameLaunchType,
    gamesYouMightLike,
    descriptionGameProvider,
    gameDescription,
    t,
    liveLaunchAlias,
    demoModeSupport
}) => {
    const liveGameConfig = useLiveGameConfig(liveLaunchAlias);
    const isLiveGame = liveGameConfig?.launchAlias;
    const { limits, seatsInfo, isScheduled } = liveGameConfig || {};
    const isScheduledLiveGame = isLiveGame && isScheduled;
    const liveLaunchAliases = useMemo(() => ({
        ...liveLaunchAlias && { liveLaunchAliases: [liveLaunchAlias] }
    }), [liveLaunchAlias]);

    useLiveGames(liveLaunchAliases);

    /* For Desktop and Tablet mockup for now */
    return (
        <div className={style.container}>
            <GameInfoTopSectionDesktop
                image={image}
                name={name}
                showFavorite={showFavorite}
                code={code}
                hideButtons={hideButtons}
                liveLaunchAlias={liveLaunchAlias}
                demoModeSupport={demoModeSupport}
                t={t}
                isScheduledLiveGame={isScheduledLiveGame}
                gameLaunchType={gameLaunchType}/>
            {description &&
                <ShortGameDescription
                    description={description}
                    title={t('playtech.mobile.system.responsivegames.game.infoPopup.einsatz')}
                    isDangerouslySetInnerHTML/>
            }
            {descriptionGameProvider &&
                <ShortGameDescription
                    description={descriptionGameProvider}
                    title={t('playtech.mobile.system.responsivegames.game.infoPopup.gameProvider')}/>
            }
            {gameDescription &&
                <ShortGameDescription
                    description={gameDescription}/>
            }
            {isLiveGame && (
                <div className={style.liveInfo}>
                    <div className={style.seatsInfo}>
                        <span className={style.seatsIcon} />
                        <span>{seatsInfo}</span>
                    </div>
                    {limits && <div className={style.liveLimits}>{limits}</div>}
                </div>
            )}
            {gamesYouMightLike?.length > 0 && (
                <div className={style.games}>
                    <div className={style.gamesTitle}>{t('playtech.mobile.system.games.youMightLike')}</div>
                    <GamesViewMini
                        gameCodes={gamesYouMightLike}
                        className={style.slider}
                        classNames={{ game: style.game }}
                        showGameInfo={true}
                    />
                </div>
            )}
        </div>
    );
};

export default memo(GameInfoDesktop);
